module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/massage-desktop-6ecb40fad91e624754e38937f648b607.jpg";